export default "__VITE_ASSET__B9Ojm8DP__"